import { render, staticRenderFns } from "./charts.vue?vue&type=template&id=150c6852"
import script from "./charts.vue?vue&type=script&lang=js"
export * from "./charts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports